import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { formInputTheme } from "../../textinput/styled/formInputTheme";
import { TypeRampV2 } from "../../typography";

interface SelectButtonTextProps {
    themeMode: RequiredThemeKeys;
}

export const SelectButtonText = styled(TypeRampV2)<SelectButtonTextProps>`
    min-width: 0;
    text-align: start;
    color: ${({ themeMode }) => `var(--sds--form--color--value, ${formInputTheme.textColor.rest(themeMode)})`};
`;
